// Single source of truth for staff role labels in the UI, derived from the account's backend role.
// Mirrors the backend map in src/config/roleLabels.js (the HR Personnel API also returns roleLabel).
export const ROLE_LABELS = {
  admin: 'Super Admin',
  adminStaff: 'Org Manager',
  billing: 'Billing',
  accounting: 'Accounting',
  enrollment: 'Enrollment Coordinator',
  doctor: 'Physician',
  HrMedical: 'Nurse',
  HrLead: 'Lead Nurse',
  HrNonMedical: 'Non-Medical Staff',
};

const ROLE_COLORS = {
  admin: '#004aad',
  adminStaff: '#6f42c1',
  billing: '#198754',
  accounting: '#0f766e',
  enrollment: '#0e7490',
  doctor: '#0d6efd',
  HrMedical: '#c2410c',
  HrLead: '#b91c1c',
  HrNonMedical: '#6c757d',
};

export const isSuperAdmin = (user) => user?.role === 'admin' && !(user?.organizationIds || []).length;

// An `admin` account scoped to organizations is not a Super Admin.
export const roleLabel = (role, organizationIds) => {
  if (role === 'admin' && (organizationIds || []).length) return 'Admin (org-scoped)';
  return ROLE_LABELS[role] || role || 'Unknown';
};

export const RoleBadge = ({ role, organizationIds, label }) => (
  <span
    style={{
      backgroundColor: ROLE_COLORS[role] || '#6c757d',
      color: '#FFF',
      padding: '3px 8px',
      borderRadius: '5px',
      fontSize: 12,
      whiteSpace: 'nowrap',
    }}
  >
    {label || roleLabel(role, organizationIds)}
  </span>
);
